import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';

import { magicLinkConsume } from '../../../api/auth/auth.api';
import { cacheStaffLoginTokens } from '../../../utils/next/auth.utils';

type Phase = 'loading' | 'error';

const MagicLinkLanding: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [phase, setPhase] = useState<Phase>('loading');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    // Strip token from URL immediately so it never appears in history / referer.
    history.replace('/login/magic');

    if (!token) {
      setPhase('error');
      return;
    }

    magicLinkConsume({ data: { token } })
      .then((resp: { data: { accessToken: string; refreshToken: string } }) => {
        cacheStaffLoginTokens(resp.data.accessToken, resp.data.refreshToken);
        // Mirror the password-login destination (EmailForm.tsx:90) so magic-link
        // logins go through the same PersonaLoadingView post-login init. Going
        // to '/' would get bounced through '/login' by RouteResolver and skip
        // PersonaLoadingView entirely.
        history.replace('/loading');
      })
      .catch(() => {
        setPhase('error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === 'loading') {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mt={8}
      px={3}
    >
      <Typography variant="h5" gutterBottom style={{ color: '#fff' }}>
        This sign-in link is no longer valid
      </Typography>
      <Typography
        align="center"
        mb={3}
        style={{ color: 'rgba(255,255,255,0.7)' }}
      >
        It may have expired or already been used.
      </Typography>
      <Button variant="contained" color="primary" href="/login">
        Request a new link
      </Button>
    </Box>
  );
};

export default MagicLinkLanding;
